import { forgotPassword } from 'helpers/api';

const state = {
    field: document.getElementById('username'),
    submit: document.getElementsByClassName('js--reset')[0],
    isFetching: false,
    error: false,
    message: '',
    statuses: {
        success: document.getElementsByClassName('js--forgot-success')[0],
        error: document.getElementsByClassName('js--forgot-error')[0],
    },
};

// ==================================================
// HANDLERS
// ==================================================

function handleStatusDisplay(el, hideAll = false) {
    const { statuses } = state;

    return hideAll
        ? Object.keys(statuses).forEach((k) => statuses[k].classList.add('none'))
        : el.classList.remove('none');
}

async function handlePasswordReset(e) {
    e.preventDefault();

    if (state.isFetching || !state.field.value.length) {
        return;
    }

    state.isFetching = true;
    state.statuses.success.innerHTML = '';

    const res = await forgotPassword(state.field.value);

    state.isFetching = false;

    if (res.status === 200) {
        state.field.value = '';
        state.statuses.success.innerHTML = res.data;
    } else {
        state.error = true;
        state.statuses.success.innerHTML = '';
    }

    return handleStatusDisplay(res.status === 200 ? state.statuses.success : state.statuses.error);
}

function handleBtnEnable(e) {
    const val = e.target.value;

    if (e.keyCode === 13) {
        return val.length ? handlePasswordReset(e) : false;
    }

    if (state.error) {
        state.error = false;

        handleStatusDisplay(null, true);
    }

    const { classList } = state.submit;
    const disabledClassFound = classList.contains('disabled');

    if (val.length && disabledClassFound) {
        classList.remove('disabled');
    }

    if (!val.length && !disabledClassFound) {
        classList.add('disabled');
    }
}

// ==================================================
// INIT
// ==================================================

function init() {
    state.field.addEventListener('keyup', (e) => handleBtnEnable(e));
    state.submit.addEventListener('click', (e) => handlePasswordReset(e));
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/forgot-password.js